import * as types from 'modules/questionModels/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {import('modules/global/generic.types').Page} State */
const initialState = {
  number: 0,
  totalElements: 0,
  totalPages: 0,
  size: 10,
};

const updateState = (state, { payload }) => ({
  ...state,
  ...payload.page,
});

const resetState = () => initialState;

export default createReducer(initialState, {
  [types.FETCH_QUESTION_MODELS_SUCCESS]: updateState,
  [types.FETCH_QUESTION_MODELS_FAILURE]: resetState,
});
